import { useTranslation } from 'react-i18next';
import { StyledButton } from './styled';

interface PropsType {
  onClick: () => void;
}

const NewReleaseButton = ({ onClick }: PropsType) => {
  const { t } = useTranslation();

  return (
    <StyledButton onClick={onClick}>
      {t('account:release:newRelease')}
    </StyledButton>
  );
};

export default NewReleaseButton;
